export default {
  url: 'https://test.mcmedic.cloudmedic.ru',
  socketurl: 'wss://test.mcmedic.cloudmedic.ru:643/client',
  lkurl: 'https://lk.test.mcmedic.ru',
}
